import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
  FormControl,
  FormLabel,
  InputAdornment,
  MenuItem,
  Select,
} from "@material-ui/core";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import Heading from "../../../StyledComponents/Heading/Heading";
import { makeStyles } from "@material-ui/styles";
import { Download } from "@material-ui/icons";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import ProceedBtn from "../NewInvoice/InvoiceGuidLines/proceedbtn";
import { ArrowBack, Delete, Error } from "@material-ui/icons";
import downloadAttachments from "../../../Functions/downloadAttachments";
import VendorCode from "../NewInvoice/Dropdowns/VenderCode";
import UsersByRole from "../NewInvoice/Dropdowns/UsersByRole";
import GL_Table from "../NewInvoice/Tables/GL_Table";
import Vendor_Table from "../NewInvoice/Tables/Vendor_Table";
import CommentHistory from "../NewInvoice/Tables/CommentHistory";
import PODetail from "../NewInvoice/Tables/PoDetail_Table";
import ExpenseTable from "../NewInvoice/Tables/ExpenseTable";
import {
  createInvoiceByIR,
  createNewInvoice,
  getCommentsByInvoiceId,
  getCommentsByERFInvoiceNo,
  getCommentsByARFInvoiceNo,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  getPODetails,
  uploadAdditioalDocumentFile,
  uploadFile,
  updateIPInvoice,
  getAllInvoiceDetailByInvoiceId,
  vendorTaxDetailForCnic,
  submit_APSInvoice,
  getRefrenceDataList,
  getBatchInvoiceDetails,
} from "../actions";
import { GetBatchInvoiceDetailsWithname } from "../ProcessInvoice/actions.js";
import InvoiceGuideLine from "../NewInvoice/InvoiceGuidLines/InvoiceGuideLine";
import CustomSnackbar from "../../../CustomSnackbar";
import moment from "moment";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import { demandType, category, invoiceType } from "../../Home/constant";
import InvoiceCheckboxes from "../Components/InvoiceDetails/InvoiceCheckboxes";
import InvoiceRadioButtons from "../Components/InvoiceDetails/InvoiceRadiobuttons";
import InvoiceTextField from "../Components/InvoiceDetails/InvoiceTextFields";
import InvoiceDetailTextField from "../Components/InvoiceDetails/InvoiceDetailTextFields";

// import PaymentDetail from "../Components/PaymentDetails/PaymentDetail";
import PaymentDetail from "../Components/PaymentDetails/PaymentDetail.js";
import PaymentDetailsTextField from "../Components/PaymentDetails/PaymentDetailsTextField";

import TaxDetail from "../Components/TaxDetails/TaxDetails";
import TaxDetailTextField from "../Components/TaxDetails/TaxDetailTextField";

import { useNavigate } from "react-router-dom";
import { getUserRoles } from "../../Home/actions";
import getParameterByName from "../../../Functions/functions";
import TaxTable_Short from "../NewInvoice/Tables/Tax_Table_Short";
import GL_Table_ProcessInvoice from "../NewInvoice/Tables/GL_Table_ProcessInvoice";
import GL_Table_Detail_HR from "../NewInvoice/Tables/GL_Table_Detail_HR.js";
import FileAttachments from "../../../components/Attachments/FileAttachments";
import POAlertDialog from "../NewInvoice/Tables/PoTableAlert";
import WarningBox from "../Components/WarningBox";
import jwt from "jsonwebtoken";
import TaxTable from "../NewInvoice/Tables/Tax_Table";
import VendorTaxTable from "../NewInvoice/Tables/Vendor_Tax_Detail";
import PaymentImport from "../NewInvoice/Payment/PaymentImport";
import { addZeroes } from "../../../Functions";
import ExpenseDetail from "../NewInvoice/Tables/ExpenseDetail.js";
import FER_Fuel_General_Allowance from "../NewInvoice/Tables/FERTables/FER_Fuel_General_Allowance.js";
import FER_General from "../NewInvoice/Tables/FERTables/FER_General.js";
import FER_Allowance from "../NewInvoice/Tables/FERTables/FER_Allowance.js";
import GL_Table_APS from "../NewInvoice/Tables/GL_Table_DetailAPS.js";
import TaxTableV2 from "../NewInvoice/Tables/TaxTableV2.jsx";
import GL_Table_V2 from "../NewInvoice/Tables/GL_Table_V2";
import RTBLineItems_Table from "../NewInvoice/Tables/RTBLineItems_Table";
import DepartmentCoordinatorRent from "../DepartmentCoordinator/DepartmentCoordinatorRent";
const useStyles = makeStyles(dashboardStyle);

const APS_InvoiceDetailPage = () => {
  const classes = useStyles();

  const navigate = useNavigate();
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const vendorCode = getParameterByName("vendorCode");
  const edit = getParameterByName("edit");

  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };

  const role = {
    roleId: roleId,
    roleName: roleName,
  };

  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );

  const [poBasedState, setPoBasedState] = useState("PO");
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(false);

  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);

  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [multipleData, setMultipleData] = useState({
    glAccount: [],
    paymentDetail: [],
    paymentMethod: [],
    paymentMethSupp: [],
    poData: [],
    vendorTaxDetail: [],
    invoice_Type: [],
    erf_ExpenseInvoice_Detail: [],
    fer_Invoice_Detial: [],
  });
  const invoice_attachmentRef = useRef(null);
  const additionalAttachmentRef = useRef(null);
  const [attachmentLoader, setAttchmentLoader] = useState(false);
  const [docError, setDocError] = useState("");

  const [formState, setFormState] = useState({
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,
    calculateTax: true,
    // LogisticInvoices: false,
    // VendorPrePayment: false,
    // VendorFinancingPayment: false,
    invoice_Id: 0,
    daysto_sale_taxlapse: 0,
    grn_No: "",
    pO_No: "",
    po_Date :"",
    plant_Code : "",


    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: 0,
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    firstClearText: "",
    secondClearText: "",
    due_Date: moment().format("YYYY-MM-DD"),
    vendor_Details: [],
    additionalDocIds_array: [], // additional documents in array
    // for Payment detail
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: true,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: moment().format("YYYY-MM-DD"),
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: moment().format("YYYY-MM-DD"),
    },
    // Tax Table data
    taxCard_List: [],
    vendor_tax_detail: [], // tax exemption
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],
    // G/L Account detail.
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "",
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      {
        poItem: "", //  item #
        poNumber: "", // poNumber
        refDoc: "", // GRN No
        quantity: "", // GRN quantity
        val_Loccur: "", // GRN amount
        invoicE_QTY: "", //  consumed quantity
        invoicE_VAL: 0, // consumed Amount
        inpuT_QTY: "", //  invoice QTY
        inpuT_VAL: "", //  Invoice amount
        currency: "", // currency
      },
    ],
    salesTaxAmount: "",
    salesTaxCode: "",
    verified: false,
  });

  const [newFormState, setNewFormState] = useState({
    invoiceId: parseInt(invoicePayload.Invoice_id),
    comments: "",
    additional_Docs: [],
    action: "Completed",
    add_Reviser: "",
    reason: "",
    posting_Date: null,
    payment_Method: "",
    house_Bank: "",
    refrence_DocNo: "",
    invoice_Desc: "",
    calculateTax: true,
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [openProceedBtn, setOpenProceedBtn] = useState(false);

  const [attachmentURL, setAttachmentURL] = useState();
  const [attachmentURLList, setAttachmentURLList] = useState([]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };

  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }

    return show;
  };

  const showVendorCodeForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }
    return show;
  };

  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue.roleName === "I2P Initiator" ? true : false,
      isHR: newValue.roleName === "HR" ? true : false,
      isPCDV: newValue.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue.roleName === "Import" ? true : false,
      isLogistics: newValue.roleName === "Logistic" ? true : false,
    }));

    setSelectedRole(newValue);
  };
  const confirmedForInvoiceCreation = () => {
    setErrorMessage("");
    submit_APSInvoice(
      newFormState,
      setErrorMessage,
      setSuccessMessage,
      setAttachInvoiceLoading,
      navigate
    );
  };
  const submitHandler = (e) => {
    e.preventDefault();
    if (
      user?.UserName === "kumar das" ||
      user?.LoginId === "44584900-7d91-460e-91f2-8b9b82bbe35f"
    ) {
      confirmedForInvoiceCreation(); //this is for Invoice proceed pop up msg: do not show this msg to KD
    } else {
      setOpenProceedBtn(true);
    }
  };
  // const submitHandler = (e) => {
  //   e.preventDefault();
  //   submit_APSInvoice(
  //     newFormState,
  //     setErrorMessage,
  //     setSuccessMessage,
  //     setAttachInvoiceLoading,
  //     navigate
  //   );
  // };
  // >>>___FileAttachment____

  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    if (invoicePayload && role) {
      //   getInvoiceByInvoiceIdAndRoleId(
      //     invoicePayload,
      //     role,
      //     setFormState,
      //     () => {},
      //     setNewFormState
      //   );
      GetBatchInvoiceDetailsWithname(
        () => {},
        () => {},
        setMultipleData,
        invoicePayload,
        role,
        setFormState,
        setDataLoading,
        setPoBasedState
      );

      //   getAllInvoiceDetailByInvoiceId(
      //     setFormState,
      //     setMultipleData,
      //     invoicePayload?.Invoice_id,
      //     () => {},
      //     () => {},
      //     "APS",
      //     () => {}
      //   );
      vendorTaxDetailForCnic(setFormState, invoicePayload?.Vendor_Code);

      setNewFormState((newFormState) => ({
        ...newFormState,
        invoice_id: invoicePayload?.Invoice_id,
      }));
    }
    getUserRoles(setRoles, setRolesLoading);
  }, []);
  useEffect(() => {
    if (invoicePayload && role) {
      if (formState?.invoice_Type === "ERF") {
        getCommentsByERFInvoiceNo(
          setCommentsList,
          setCommentsLoading,
          formState?.invoice_No
        );
      }

        else if (formState?.invoice_Type === "ARF") {
              getCommentsByARFInvoiceNo(
                setCommentsList,
                setCommentsLoading,
                formState?.invoice_No
              );
            }
      
      else {
        getCommentsByInvoiceId(
          setCommentsList,
          setCommentsLoading,
          invoicePayload?.Invoice_id
        );
      }
    }
  }, [formState.invoice_Type]);
  // useEffect(() => {
  //   if (formState?.additionalDocIds?.length > 0) {
  //     const filterd = formState?.additionalDocIds?.filter((x) => x !== "");

  //     setAttachmentURLList((pre) => [
  //       ...pre,
  //       formState?.invoice_attachment,
  //       ...filterd,
  //     ]);
  //     if (formState?.invoice_attachment) {
  //       setAttachmentURL(formState?.invoice_attachment);
  //     } else {
  //       setAttachmentURL(formState?.additionalDocIds[0]);
  //     }
  //     // setAttachmentURL(formState?.invoice_attachment);
  //   }
  // }, [formState?.additionalDocIds]);

  const [firstTime, setFirstTime] = useState(true);

  useEffect(() => {
    if (
      // selectedRole.roleName === "APS" &&
      formState?.additionalDocIds?.length > 0
    ) {
      let filterd_data = [];
      filterd_data = formState?.additionalDocIds.filter((x) => x?.path !== "");
      var semiFinal = filterd_data.filter(function (item) {
        return !attachmentURLList.includes(item?.path);
      });

      let i = [formState?.invoice_attachment?.path];
      var final = semiFinal.filter(function (item) {
        return !i.includes(item?.path);
      });
      if (firstTime) {
        setFirstTime(false);
        setAttachmentURLList([...final, formState?.invoice_attachment]);
        setAttachmentURL(formState?.invoice_attachment);
      } else {
        if (final.length > 0) {
          setAttachmentURLList([...final, formState?.invoice_attachment]);
          setAttachmentURL(final[0]);
        }
      }
    } else if (formState?.invoice_attachment?.path) {
      setAttachmentURLList([formState?.invoice_attachment]);
      setAttachmentURL(formState?.invoice_attachment);
    }
  }, [formState?.additionalDocIds, formState?.invoice_attachment]);

  useEffect(() => {
    if (newFormState.additional_Docs?.length > 1) {
      setAttachmentURLList((pre) => [
        ...pre,
        newFormState.additional_Docs[newFormState.additional_Docs.length - 1],
      ]);
    } else {
      setAttachmentURLList((pre) => [...pre, ...newFormState.additional_Docs]);
    }
  }, [newFormState?.additional_Docs]);
  useEffect(() => {
    if (formState?.invoice_Id !== 0) {
      setPoBasedState(formState?.pO_Based ? "PO" : "Non-PO");
    }
  }, [formState]);

  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => {},
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentTerm",
      "paymentTerms",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethod",
      "paymentMethod",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "postingKey",
      "postingKey",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethodSupp",
      "paymentMethSupp",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList("sglInd", "sglInd", setFormState, setMultipleData);
  }, []);

  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);
  const clearState = () => {
    setNewFormState((newFormState) => ({
      ...newFormState,
      // additional_Docs: [],
      add_Reviser: "",
      reason: "",
      posting_Date: null,
      payment_Method: "",
      house_Bank: "",
      refrence_DocNo: "",
      invoice_Desc: "",
    }));
  };
  const [invoicedelete, setInvoiceDelete] = useState("");
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [openWarningBox, setOpenWarningBox] = useState(false);
  const deleteAttachmentFunc = () => {
    const data = {
      Id: invoicedelete?.id,
    };
    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
        const final = attachmentURLList?.filter(
          (x) => x?.path !== invoicedelete?.path
        );
        const files = newFormState.additional_Docs.filter(
          (x, i) => x.path !== invoicedelete?.path
        );
        setAttachmentURLList(final);

        setNewFormState((formState) => ({
          ...formState,
          additional_Docs: files,
        }));

        setdeleteLoader(false);
        setOpenWarningBox(false);

        setSuccessMessage(response.data);
      })
      .catch(function (error) {
        setErrorMessage(error.response.data);
      });
  };
  const [dragfile, setDragFile] = useState(false);
  const [dragloader, setDragLoader] = useState(false);
  const [attachError, setAttachError] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragLoader(true);
    } else if (e.type === "dragleave") {
      setDragLoader(false);
      setDragFile(true);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragLoader(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      uploadAdditioalDocumentFile(
        e,
        setNewFormState,
        setAttchmentLoader,
        "additional_Docs",
        additionalAttachmentRef,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
    }
  };

  const isContainEmailFormate = (fileExtension) => {
    const emailExtensions = [
      "eml",
      "msg",
      "pst",
      "mbox",
      "emlx",
      "dbx",
      "mbx",
      "nws",
      "p7m",
      "mht",
      "mhtml",
      "rar",
      "zip",
    ];
    return emailExtensions.includes(fileExtension.toLowerCase());
  };
  return (
    <Card
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={dataLoading || dragloader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "0px 27px",
            backgroundColor: "#031C30",
            color: "white",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={2} sm={3} md={3} lg={6}>
              <h1 style={{ fontSize: "24px" }}>APS Review</h1>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={attachInvoiceLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <Grid container spacing={2} style={{ marginTop: "1px" }}>
              {/* Submitter role */}
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography style={{ color: "black" }}>
                  Submitter Role:
                </Typography>
                <Autocomplete
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "30px",
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiInputBase-input": {
                      marginTop: "-4px", // Adjust this value to move the text up
                      fontSize: 15,
                    },
                  }}
                  id="submitter_role"
                  options={roles}
                  size="small"
                  value={selectedRole}
                  getOptionLabel={(option) =>
                    (option !== "" && `${option?.roleName}`) || ""
                  }
                  loading={rolesLoading}
                  onChange={(event, newValue) => {
                    roleHandler(newValue);
                  }}
                  disabled
                  renderInput={(params) => (
                    <TextField {...params} type="text" name="" required />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
            </Grid>
            {!formState.isImport && !formState?.isPCDV && (
              <InvoiceCheckboxes
                formState={formState}
                setFormState={setFormState}
                selectedRole="IP"
                disabled={true}
              />
            )}
            {!formState.isImport && !formState?.isPCDV && (
              <InvoiceRadioButtons
                formState={formState}
                setFormState={setFormState}
                selectedRole="IP"
                physicalOrEInvoice={physicalOrEInvoice}
                poBasedState={poBasedState}
                alignForAttachment={true}
              />
            )}
            {/* <InvoiceTextField
              newFormState={formState}
              setNewFormState={setFormState}
              selectedRole="IP"
              disabled={true}
              poBasedState={poBasedState}
              showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
              showVendorCodeForImport={showVendorCodeForImport}
              invoice_attachmentRef={invoice_attachmentRef}
              additionalAttachmentRef={additionalAttachmentRef}
              setAttachInvoiceLoading={setAttachInvoiceLoading}
              //   setAttchmentFile_UI={setAttchmentFile_UI}
              //   attachmentFile_UI={attachmentFile_UI}
              physicalOrEInvoice={physicalOrEInvoice}
              changeHandler={changeHandler}
              alignForAttachment={true}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURLList={attachmentURLList}
              setAttachmentURL={setAttachmentURL}
              showAttachmentsHandler={showAttachmentsHandler}
              multipleData={multipleData}
            />*/}
            <InvoiceDetailTextField
            formState={formState}
              newFormState={formState}
              setNewFormState={setFormState}
              selectedRole="IP"
              disabled={true}
              poBasedState={poBasedState}
              showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
              showVendorCodeForImport={showVendorCodeForImport}
              invoice_attachmentRef={invoice_attachmentRef}
              additionalAttachmentRef={additionalAttachmentRef}
              setAttachInvoiceLoading={setAttachInvoiceLoading}
              //   setAttchmentFile_UI={setAttchmentFile_UI}
              //   attachmentFile_UI={attachmentFile_UI}
              physicalOrEInvoice={physicalOrEInvoice}
              changeHandler={changeHandler}
              alignForAttachment={true}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURLList={attachmentURLList}
              setAttachmentURL={setAttachmentURL}
              showAttachmentsHandler={showAttachmentsHandler}
              multipleData={multipleData}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            style={{ paddingLeft: "7px" }}
          >
            <Heading title="  Attachment Preview" />

            <AttachmentsCover
              attachmentURLList={attachmentURLList}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURL={attachmentURL}
              setAttachmentURL={setAttachmentURL}
              formState={formState}
              invoice_attachmentRef={invoice_attachmentRef}
            />
          </Grid>
        </Grid>
        {/* payment detail */}

        {/* {formState.pO_No && !formState?.isLogistics && (
         <PaymentDetail
            formState={formState}
            setFormState={setFormState}
            multipleData={multipleData}
            disabled={true}
        />
       )}*/}

        {!formState?.isLogistics && (
          <PaymentDetailsTextField
            formState={formState}
            setFormState={setFormState}
            multipleData={multipleData}
            disabled={true}
          />
        )}

        {/* Tax  */}
        {formState.invoice_Type !== "DES" &&
          formState.invoice_Type !== "ERF" &&
          formState.invoice_Type !== "FER" && (
            <>
              <Heading title="Tax" />

              {/* <TaxDetail
   // formState={newFormState}
   // setFormState={setNewFormState}
   formState={formState}
   setFormState={setFormState}
   invoice_Amount={newFormState.invoice_Amount}
   disabled={true}
   roleName={roleName}
 />*/}
              <TaxDetailTextField
                // formState={newFormState}
                // setFormState={setNewFormState}
                formState={formState}
                setFormState={setFormState}
                invoice_Amount={formState.invoice_Amount}
                disabled={true}
                roleName={roleName}
              />
              {formState?.invoice_No && formState?.taxCard_List.length > 0 && (
                <TaxTableV2
                  formState={formState}
                  setFormState={setFormState}
                  invoice_Amount={formState.invoice_Amount}
                  invoicePayload={invoicePayload}
                  show={true} // to disable the add new button
                  edit={false}
                  isProceed={false} //required
                  setTaxErrorMsg={() => {}}
                  taxErrorMsg={() => {}}
                />
              )}
              {formState.invoice_No &&
                formState?.vendor_tax_detail?.length > 0 && (
                  <VendorTaxTable
                    formState={formState}
                    setFormState={setFormState}
                  />
                )}
            </>
          )}
                    {/* {(
  formState?.rtbId
) && (
  <Grid container spacing={2} marginY={2}>
    <Grid item xs={12}>
      <RTBLineItems_Table 
      formState={formState}
      setFormState={setFormState}
      setSelectedTotal={() => {}}
      selectedRole={selectedRole}
      />
    </Grid>
  </Grid>
)} */}


        {/* <TaxTable_Short
          formState={formState}
          setFormState={setFormState}
          invoicePayload={invoicePayload}
          disabled={true}
        /> */}
        <span></span>
        {formState.invoice_Type === "ERF" && (
          <ExpenseDetail multipleData={multipleData} />
        )}
        {formState.invoice_Type === "FER" && (
          <>
            <FER_Fuel_General_Allowance multipleData={multipleData} />
          </>
        )}
        {formState.invoice_Type !== "ERF" &&
          formState.invoice_Type !== "FER" && (
            <>
              {formState?.invoice_Accounts?.length > 0 &&
                formState?.invoice_Accounts?.length > 0}
              <Typography variant="h4" style={{ margin: "20px 0px 10px 0px" }}>
                <Heading title="G/L Account" />
              </Typography>
              {/* G/L Account */}
              {formState?.isHR ? (
                <GL_Table_Detail_HR formState={formState} />
              ) : (
                 formState?.invoice_Type === 'Final Settlement - Distributor' ?
                
                                        <GL_Table_V2
                                         formState={formState}
                                          setFormState={setFormState}
                                          show={false}
                                          reviwerFlag={ true }
                                          role={"IR"}                        />
                                         
                
                                          :
                <GL_Table_APS
                  formState={formState}
                  setFormState={setFormState}
                  setGLAccountTotal={() => {}}
                  importPaymentDetail={() => {}}
                  disabled={true}
                  setImportPaymentDetail={() => {}}
                  setErrorMessageForAmount={() => {}}
                />
                //   <GL_Table_ProcessInvoice
                //   formState={formState}
                //   setFormState={setFormState}
                //   disabled={true}
                //   setGLAccountTotal={() => { }}
                //   importPaymentDetail={[]}
                //   setImportPaymentDetail={() => { }}
                // />
              )}
            </>
          )}

        {formState?.pO_Based &&
          formState?.invoice_Type !== "ERF" &&
          formState.invoice_Type !== "FER" && (
            <>
              <PODetail
                formState={formState}
                setFormState={setFormState}
                disabled={true}
              />

              <Grid container spacing={2}>
                <Grid item sm={6} md={3} lg={1}>
                  <b>GRN Total:</b>
                </Grid>
                <Grid item sm={6} md={3} lg={2}>
                  <b>
                    {addZeroes(
                      formState?.invoicePORef_List
                        ?.map((data) => data.inpuT_VAL)
                        .reduce((prev, curr) => Number(prev) + Number(curr), 0)
                    )}
                  </b>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item sm={6} md={3} lg={1}>
                  <b>Total Cost:</b>
                </Grid>
                <Grid item sm={6} md={3} lg={2}>
                  <b>
                    {addZeroes(
                      Number(
                        formState?.invoicePORef_List
                          ?.map((data) => data.inpuT_VAL)
                          .reduce(
                            (prev, curr) => Number(prev) + Number(curr),
                            0
                          )
                      ) +
                        Number(
                          formState?.invoice_Accounts
                            ?.map((data) => data.amount)
                            .reduce(
                              (prev, curr) => Number(prev) + Number(curr),
                              0
                            )
                        )
                    )}
                  </b>
                </Grid>
              </Grid>
            </>
          )}
        {!formState.pO_Based &&
          formState.invoice_Type !== "ERF" &&
          formState.invoice_Type !== "FER" && (
            <PaymentImport
              formState={formState}
              vendor={{
                name: formState?.vendor_Name || "",
                code: formState?.vendor_Code || "",
              }}
              inv_amount={formState?.invoice_Amount}
              invoiceData={{
                taxCode: formState?.salesTaxCode,
                taxAmount: Number(formState?.salesTaxAmount),
                GLInvoice_Accounts: formState?.invoice_Accounts,
                isPCDV: formState?.isPCDV,
                vendor_Code: formState?.vendor_Code,
              }}
              setImportPaymentDetail={() => {}}
              setFormState={() => {}}
              formState1={newFormState}
              multipleData={multipleData}
              edit={true}
              disable={true}
            />
          )}
                      {formState.invoice_Type=='Rent' &&
                            <Grid container spacing={0} style={{ marginTop: "0px" }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
          
                                <DepartmentCoordinatorRent 
                                  formState={formState}
                                  setFormState={setFormState}
                                  show={false}
                                  reviwerFlag={false}
                                  role={(selectedRole?.roleName === "Department Coordinator" && formState.invoice_Type=='Rent')?"":"HR"}    />
          </Grid>
                          </Grid>
           }
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <CommentHistory
            commentsList={commentsList}
            commentsLoading={commentsLoading}
          />
        </Grid>
        {formState.isImport &&
          formState.demandType !== "Deposit" &&
          formState?.vendor_Details?.length > 0 && (
            <Grid container spacing={2} style={{ margin: "20px 0px" }}>
              <Grid item xs={12} sm={12} md={3} lg={12}>
                <Typography
                  variant="h4"
                  style={{ margin: "20px 0px 10px 0px" }}
                >
                  <Heading title="Clearing Detail" />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Typography
                  variant="h5"
                  style={{ color: "black", fontStyle: "bold" }}
                >
                  First Clearing Text:{" "}
                  <span
                    style={{
                      color: "#999",
                      fontSize: "14px",
                      cursor: "default",
                    }}
                  >
                    {formState?.firstClearText}
                  </span>
                </Typography>
              </Grid>
              {formState?.isPSID && (
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <Typography
                    variant="h5"
                    style={{ color: "black", fontStyle: "bold" }}
                  >
                    Second Clear Text:{` `}
                    <span
                      style={{
                        color: "#999",
                        fontSize: "14px",
                        cursor: "default",
                      }}
                    >
                      {formState?.secondClearText}
                    </span>
                  </Typography>
                </Grid>
              )}
            </Grid>
          )}
        {formState.isImport &&
          formState.demandType !== "Deposit" &&
          formState?.vendor_Details?.length > 0 && (
            <Vendor_Table
              formState={formState}
              setFormState={setFormState}
              disabled={true}
            />
          )}
        {edit === "false" && (
          <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
            <Typography style={{ color: "black" }}>
              Additional Document:{" "}
            </Typography>
            <TextField
              fullWidth
              size="small"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <input
                      ref={additionalAttachmentRef}
                      type="file"
                      name="additional_Docs"
                      onChange={(e) =>
                        uploadAdditioalDocumentFile(
                          e,
                          setNewFormState,
                          setAttchmentLoader,
                          "additional_Docs",
                          additionalAttachmentRef,
                          setDocError,
                          setAttachError,
                          setAlertMessage,
                          invoicePayload,
                          selectedRole,
                          dragfile,
                          setDragFile,
                          setSuccessMessage
                        )
                      }
                      style={{ width: "209px" }}
                      multiple
                    />

                    {attachmentLoader ? <CircularProgress size={24} /> : ""}
                  </InputAdornment>
                ),
              }}
              // FormHelperTextProps={{
              //   className: classes.helperText,
              // }}
              // error={docError ? true : false}
              // helperText={docError ? `${docError}` : null}
            />
            {newFormState.additional_Docs.length > 0 &&
              newFormState.additional_Docs.map((f, index) => {
                const s = f?.path.split("\\");
                const ss = s[s.length - 1];
                // above 2 lines is for get name of file
                return (
                  <>
                    {f?.path !== "" ? (
                      <>
                        <IconButton>
                          <Download
                            onClick={() => {
                              const files = newFormState.additional_Docs.find(
                                (x, i) => {
                                  const n = x?.path?.split("\\");
                                  const nn = n[n.length - 1];
                                  return nn === ss;
                                }
                              );
                              downloadAttachments(files?.path);
                            }}
                            color="secondary"
                          />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => {
                            setInvoiceDelete(f);
                            setOpenWarningBox(true);
                          }}
                        >
                          <Delete
                            color="danger"
                            fontSize="small"
                            style={{
                              color:
                                f.role_Name !== selectedRole?.roleName
                                  ? "gray"
                                  : "",
                            }}
                          />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={() => {
                            const extension = f.path
                              ?.match(/\.[^.]+$/)[0]
                              .substring(1);
                            const allowedExtensions = [
                              ".png",
                              ".pdf",
                              ".jpg",
                              ".jpeg",
                              ".PNG",
                              ".JPG",
                              ".JPEG",
                              ".PNG",
                              ".PDF",
                            ];
                            const fileExtension = "." + ss.split(".").pop();
                            if (allowedExtensions.includes(fileExtension)) {
                              setAttachmentURL(f);
                            } else {
                              if (isContainEmailFormate(extension)) {
                                downloadAttachments(f.path);
                              } else {
                                setAttachmentURL(f);

                                window.open(
                                  `${process.env.REACT_APP_API_URL}/${f.path}`,
                                  "_blank"
                                );
                              }
                            }
                          }}
                        >
                          <span style={{ fontSize: "12px" }}>{ss}</span>
                        </IconButton>
                        <div></div>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
          </Grid>
        )}
        {edit === "true" ? (
          <form onSubmit={submitHandler} style={{ marginTop: "50px" }}>
            <>
              <Grid container style={{ margin: "5px 0px" }}>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <FormControl fullWidth size="small">
                    <Typography style={{ color: "black" }}>
                      Action:<span className={classes.asterisk}>*</span>
                    </Typography>

                    <Select
                      size="small"
                      // labelId="demo-simple-select-label"
                      value={newFormState?.action}
                      name="action"
                      required
                      placeholder="Select an Action"
                      className={classes.selectEmpty}
                      displayEmpty
                      // disabled={roleName === "AP Manager"}
                      id="demo-simple-select"
                      onChange={(e) => {
                        changeHandler(e);
                        // clearState();
                      }}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="" disabled>
                        Select an Action
                      </MenuItem>
                      {[
                        {
                          action: "Add reviewer/ approver",
                          value: "Add reviewer/ approver",
                        },
                        { action: "Rework", value: "Rework" },
                        { action: "Reverse", value: "Reverse" },
                        { action: "Change", value: "Change" },
                        { action: "Ok For Payment", value: "Completed" },
                        { action: "Approve but not for payment", value: "ApproveOnly" },
                      ].map((item) => {
                        return (
                          <MenuItem value={item.value}>{item.action}</MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                {newFormState?.action === "Add reviewer/ approver" && (
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <FormControl fullWidth size="small">
                      <UsersByRole
                        label="Add Reviewer"
                        apiString="All"
                        placeholder="Select a Reviewer"
                        name="add_Reviser" // pending.
                        formState={newFormState}
                        setNewFormState={setNewFormState}
                        changeHandler={changeHandler}
                        required={true}
                        classes={classes}
                      />
                    </FormControl>
                  </Grid>
                )}
                {newFormState?.action === "Reverse" && (
                  <>
                    <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                      <FormControl fullWidth size="small">
                        <Typography style={{ color: "black" }}>
                          <span className={classes.asterisk}>*</span>Reason:
                        </Typography>

                        <Select
                          size="small"
                          // labelId="demo-simple-select-label"
                          value={newFormState?.reason}
                          name="reason"
                          id="demo-simple-select"
                          required
                          onChange={changeHandler}
                          inputProps={{ "aria-label": "Without label" }}
                          displayEmpty
                          className={classes.selectEmpty}
                        >
                          <MenuItem value="" disabled>
                            Select a Value
                          </MenuItem>
                          {[
                            {
                              text: "01 - Reversal in current period",
                              value: "01 - Reversal in current period",
                            },
                            {
                              text: "02 - Reversal in closed period",
                              value: "02 - Reversal in closed period",
                            },
                            {
                              text: "03 - Actual reversal in current period",
                              value: "03 - Actual reversal in current period",
                            },
                            {
                              text: "04 - Actual reversal in closed period",
                              value: "04 - Actual reversal in closed period",
                            },
                          ].map((item) => {
                            return (
                              <MenuItem value={item.value}>
                                {item.text}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                      <Typography style={{ color: "black" }}>
                        <span className={classes.asterisk}>*</span>Posting Date:
                      </Typography>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          // value={value}
                          onChange={(newValue) => {
                            setNewFormState((formState) => ({
                              ...newFormState,
                              posting_Date: newValue,
                            }));
                          }}
                          value={newFormState?.posting_Date}
                          error={false}
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              size="small"
                              name="posting_Date"
                              id="outlined-basic"
                              variant="outlined"
                              onChange={changeHandler}
                              required
                              {...params}
                              error={false}
                              sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              }}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </>
                )}
                {newFormState?.action === "Change" && (
                  <>
                    <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                      <FormControl fullWidth size="small">
                        <Typography style={{ color: "black" }}>
                          <span className={classes.asterisk}>*</span>
                          Payment Method:
                        </Typography>

                        <TextField
                          type="text"
                          size="small"
                          name="payment_Method"
                          value={newFormState?.payment_Method}
                          variant="outlined"
                          required
                          onChange={changeHandler}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                      <FormControl fullWidth size="small">
                        <Typography style={{ color: "black" }}>
                          <span className={classes.asterisk}>*</span>
                          House Bank:
                        </Typography>

                        <TextField
                          type="text"
                          size="small"
                          name="house_Bank"
                          value={newFormState?.house_Bank}
                          variant="outlined"
                          required
                          onChange={changeHandler}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                      <FormControl fullWidth size="small">
                        <Typography style={{ color: "black" }}>
                          <span className={classes.asterisk}>*</span>
                          Reference Doc No:
                        </Typography>

                        <TextField
                          type="text"
                          sx={{
                            // width: "70%",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="outlined-basic"
                          size="small"
                          name="refrence_DocNo"
                          value={newFormState?.refrence_DocNo}
                          variant="outlined"
                          required
                          onChange={changeHandler}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <FormControl fullWidth size="small">
                        <Typography style={{ color: "black" }}>
                          <span className={classes.asterisk}>*</span>Invoice
                          Description:
                        </Typography>

                        <TextField
                          sx={{
                            // width: "70%",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="outlined-basic"
                          type="text"
                          size="small"
                          name="invoice_Desc"
                          value={newFormState?.invoice_Desc}
                          variant="outlined"
                          required
                          onChange={changeHandler}
                        />
                      </FormControl>
                    </Grid>
                  </>
                )}

                <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                  <Typography style={{ color: "black" }}>
                    Additional Document:{" "}
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    sx={{
                      // width: "70%",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <input
                            ref={additionalAttachmentRef}
                            type="file"
                            name="additional_Docs"
                            onChange={(e) =>
                              uploadAdditioalDocumentFile(
                                e,
                                setNewFormState,
                                setAttchmentLoader,
                                "additional_Docs",
                                additionalAttachmentRef,
                                setDocError,
                                setAttachError,
                                setAlertMessage,
                                invoicePayload,
                                selectedRole,
                                dragfile,
                                setDragFile,
                                setSuccessMessage
                              )
                            }
                            style={{ width: "209px" }}
                            multiple
                          />

                          {attachmentLoader ? (
                            <CircularProgress size={24} />
                          ) : (
                            ""
                          )}
                        </InputAdornment>
                      ),
                    }}
                    // FormHelperTextProps={{
                    //   className: classes.helperText,
                    // }}
                    // error={docError ? true : false}
                    // helperText={docError ? `${docError}` : null}
                  />
                  {newFormState.additional_Docs.length > 0 &&
                    newFormState.additional_Docs.map((f, index) => {
                      const s = f?.path.split("\\");
                      const ss = s[s.length - 1];
                      // above 2 lines is for get name of file
                      return (
                        <>
                          {f?.path !== "" ? (
                            <>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setInvoiceDelete(f);
                                  setOpenWarningBox(true);
                                }}
                              >
                                <Delete
                                  color="danger"
                                  fontSize="small"
                                  style={{
                                    color:
                                      f.role_Name !== selectedRole?.roleName
                                        ? "gray"
                                        : "",
                                  }}
                                />
                              </IconButton>
                              <IconButton>
                                <Download
                                  onClick={() => {
                                    const files =
                                      newFormState.additional_Docs.find(
                                        (x, i) => {
                                          const n = x?.path?.split("\\");
                                          const nn = n[n.length - 1];
                                          return nn === ss;
                                        }
                                      );
                                    downloadAttachments(files?.path);
                                  }}
                                />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  const allowedExtensions = [
                                    ".png",
                                    ".pdf",
                                    ".jpg",
                                    ".jpeg",
                                    ".PNG",
                                    ".JPG",
                                    ".JPEG",
                                    ".PNG",
                                    ".PDF",
                                  ];
                                  const fileExtension =
                                    "." + ss.split(".").pop();
                                  if (
                                    allowedExtensions.includes(fileExtension)
                                  ) {
                                    setAttachmentURL(f);
                                  } else {
                                    setAttachmentURL(f);

                                    window.open(
                                      `${process.env.REACT_APP_API_URL}/${f.path}`,
                                      "_blank"
                                    );
                                  }
                                }}
                              >
                                <span style={{ fontSize: "12px" }}>{ss}</span>
                              </IconButton>
                              <div></div>
                            </>
                          ) : (
                            ""
                          )}
                        </>
                      );
                    })}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ marginTop: "6px" }}
                >
                  <Typography style={{ color: "black" }}>
                    Comments:
                    {(newFormState?.action == "Rework" ||
                      newFormState?.action == "Reverse") && (
                      <span className={classes.asterisk}>*</span>
                    )}
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={2}
                    maxRows={4}
                    // size="small"
                    sx={{
                      // width: "70%",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    required={
                      newFormState?.action == "Rework" ||
                      newFormState?.action == "Reverse"
                        ? true
                        : false
                    }
                    name="comments"
                    value={newFormState.comments}
                    onChange={changeHandler}
                  />
                </Grid>
              </Grid>
              {(selectedRole?.roleName === "AP Supervisor" ||
                selectedRole?.roleName === "AP GM" ||
                selectedRole?.roleName === "AP Manager") && (
                <Grid container justifyContent="flex-end">
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Button
                      style={{ margin: "2px 0px", float: "right" }}
                      variant="contained"
                      color="secondary"
                      type="submit"
                    >
                      Submit
                    </Button>
                    <Button
                      style={{
                        margin: "2px 10px 0px 0px",
                        float: "right",
                        color: "white",
                      }}
                      variant="contained"
                      color="danger"
                      onClick={() => navigate("/home")}
                    >
                      CANCEL
                    </Button>
                  </Grid>
                </Grid>
              )}
            </>
          </form>
        ) : (
          ""
        )}
      </CardBody>

      {openInvoiceGuideLine && (
        <InvoiceGuideLine
          open={openInvoiceGuideLine}
          close={setOpenInvoiceGuideLine}
        />
      )}
      {openProceedBtn && (
        <ProceedBtn
          open={openProceedBtn}
          close={() => setOpenProceedBtn(false)}
          submit={confirmedForInvoiceCreation}
          attachInvoiceLoading={attachInvoiceLoading}
          formState={newFormState}
        />
      )}
      {successMessage && (
        <CustomSnackbar
          open={successMessage !== ""}
          message={successMessage}
          handleClose={() => setSuccessMessage("")}
          variant="success"
        />
      )}
      {errorMessage && (
        <>
          {" "}
          <Grid container spacing={0}>
            <Grid item>
              <Error
                titleAccess="Error"
                className={classes.asterisk}
                fontSize="small"
              />{" "}
            </Grid>
            <Grid item>
              <Typography className={classes.asterisk} ml={1}>
                {" "}
                {errorMessage}
              </Typography>
            </Grid>
          </Grid>
        </>
      )}
      {alertMessage && (
        <POAlertDialog
          setAlertMessage={setAlertMessage}
          message={attachError ? attachError : docError}
          setAttachError={setAttachError}
          setDocError={setDocError}
        />
      )}
      {openWarningBox && (
        <WarningBox
          open={openWarningBox}
          close={() => setOpenWarningBox(false)}
          submit={deleteAttachmentFunc}
          message="Are you sure you want to delete an attachment"
          deleteLoader={deleteLoader}
          allow={1}
        />
      )}
    </Card>
  );
};

export default APS_InvoiceDetailPage;
